import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import LocalStorage from '../Helpers/LocalStorage';
import styled from 'styled-components';
import SpinnerComponent from '../Components/GenericComponents/SpinnerComponent';
import { closeIfSecondaryWindow } from '../Helpers/navigationHelper';
import { useAuthService } from '../Context/AuthContext';
import { needsSsoOnboarding } from '../Helpers/userProfile';

const SsoAuthPage = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const { getCurrentUser } = useAuthService();
    const handleTokens = async () => {
        const ssoAccessToken = searchParams.get("token");
        const ssoRefreshToken = searchParams.get("refresh_token");

        if (ssoAccessToken && ssoAccessToken != "") {
            LocalStorage.setSSOFlag(true);
            LocalStorage.setAuthenthicationToken(ssoAccessToken);
            LocalStorage.setRefreshToken(ssoRefreshToken);

            if (window.electron) {
                if (typeof window.electron.sendSSOTokenToMainWindow === "function") {
                    await window.electron.sendSSOTokenToMainWindow({ token: ssoAccessToken, refreshToken: ssoRefreshToken });
                }
                await closeIfSecondaryWindow();
            } else {
                getCurrentUser(
                    (response) => {
                        const userResponse = response.data.user;
                        const conferenceBackTo = sessionStorage.getItem("conference_sign_in_back_to");
                        if (conferenceBackTo) {
                            sessionStorage.removeItem("conference_sign_in_back_to");
                            navigate(conferenceBackTo);
                        } else if (userResponse.language != null && !needsSsoOnboarding(userResponse)) {
                            navigate("/");
                        } else {
                            navigate("/onboarding");
                        }
                    },
                    () => { navigate("/login"); }
                );
            }
        } else {
            navigate('/login')
        }
    }

    useEffect(() => {
        handleTokens();
    }, [])

    return (
        <SpinnerComponent isLoading={isLoading}>
            <Container>
            </Container>
        </SpinnerComponent>
    )
}

export default SsoAuthPage
const Container = styled.div`
display:flex;
max-height:100vh;
height:100%;
min-height:600px;
width:100%;
align-items:center;
overflow:auto;
position:relative;
`
